import { SocketSlice } from "./types"
import { UserChannelMessage, UserChannelMessageType } from "@nova/schemas"
import { setGlobalNotificationContext } from "user/profile/slice"
import { invalidateNotifications } from "panels/notifications/NotificationQueries"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export default {
    events: {
        userChannelMessage: (store) => (message: UserChannelMessage) => {
            switch (message.type) {
                case UserChannelMessageType.Notification:
                    invalidateNotifications()
                    if (message.notification.orgId !== selectActiveWorkspaceId()(store.getState()))
                        return
                    store.dispatch(
                        setGlobalNotificationContext({
                            kind: "notification",
                            notification: message.notification,
                        })
                    )
                    return
            }
        },
    },
} as SocketSlice
